module.exports = __webpack_public_path__ + "static/preview-summer-catchers-2885b60cfb7bec020d4e8eea24f50e34.png";